import layout from "~/layout/App/Main.vue";
import auth from "../middleware/auth";

const databasesRoutes = {
  path: "/databases",
  component: layout,
  name: "databases",
  children: [
    {
      path: "",
      component: () => import("~/views/Database/Index"),
      name: "databases.index",
      meta: {
        middleware: auth
      }
    },
    {
      path: "edit",
      component: () => import("~/views/Database/Edit"),
      name: "databases.edit",
      meta: {
        middleware: auth
      }
    }
  ]
};

export default databasesRoutes;
